import NiceModal from "@ebay/nice-modal-react";
import { medusaRequester, requester, storeRequester } from "App";
import clsx from "classnames";
import CustomIcon from "components/icons/CustomIcon";
import P from "components/P";
import SkeletonImage from "components/skeleton/SkeletonImage";
import SkeletonText from "components/skeleton/SkeletonText";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { WishReducer } from "shared/redux/reducers/shopping/WishReducer";
import { addCommas } from "shared/utils/Utils";
import style from "./RankProductCard.module.scss";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";

function RankProductCard(props) {
  const { data, type, skeleton } = props;
  const { userName } = useContext(AuthContext);
  const { isMobile } = useContext(BrowserDetectContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [wish, setWish] = useState(false);
  const dispatch = useDispatch();
  const { products } = useSelector((state) => ({
    products: state.wish.products,
  }));

  const onProductClick = () => {
    navigate(
      `/product/detail/${type === "variant" ? data.product_id : data.id}`
    );
  };
  const addCartButtonClick = (e) => {
    e.stopPropagation();
    NiceModal.show("addCartCount", { product: data });
  };
  const wishButtonClick = async (e) => {
    e.stopPropagation();
    const { customer } = await storeRequester.getCurrentCustomer();
    let interestData = {
      product_id: data.id,
      customer_id: customer.id,
    };
    if (interestData.product_id && interestData.customer_id) {
      medusaRequester
        .addWishProduct(interestData, (result) => {
          toast.success(t("위시리스트 추가 완료"), {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        })
        .catch((error) => {});
    }
  };

  const GiftSticker = () => {
    return (
      <>
        {data.gift && (
          <div
            style={{
              width: 50,
              height: 50,
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 100,
              backgroundColor: "#0a8fff",
              borderRadius: "100%",
              padding: "5px 10px",
            }}
          >
            <Center>
              <P
                weight={800}
                color={"white"}
              >{`${data.giftStandard} + ${data.gift}`}</P>
            </Center>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    if (products && data) {
      let wishYn = false;

      products.map((wish) => {
        if (wish.productId === data.id && wish.userId) {
          wishYn = wish.wishYn;
        }
      });
      setWish(wishYn);
    }
  }, [products]);

  useEffect(() => {
    if (products && data) {
      let wishYn = false;

      products.map((wish) => {
        if (wish.productId === data.id && wish.userId) {
          wishYn = wish.wishYn;
        }
      });
      setWish(wishYn);
    }
  }, [data]);

  return (
    <div className={style.wrap} onClick={onProductClick}>
      <VerticalFlex>
        <FlexChild borderBottomRightRadius={"0"}>
          {skeleton ? (
            <div
              className={style.thumbnail}
              style={{ backgroundColor: "#ebebeb" }}
            >
              <SquareWrapper>
                {skeleton ? (
                  <SkeletonImage width={100} />
                ) : (
                  <img className={style.image} src={data.thumbnail} alt={""} />
                )}
              </SquareWrapper>
            </div>
          ) : (
            <div
              className={style.thumbnail}
              style={{ backgroundColor: `${data.bgColor}11` }}
            >
              <GiftSticker />
              <SquareWrapper>
                {props.rank && (
                  <div
                    className={
                      isMobile ? style.mobileIndexCircle : style.indexCircle
                    }
                    style={{
                      backgroundColor:
                        props.rank === 1 && "rgba(41, 106, 255, 0.8)",
                    }}
                  >
                    <P size={isMobile ? 14 : 18} weight={700}>
                      {props.rank}
                    </P>
                  </div>
                )}
                <img className={style.image} src={data.thumbnail} alt={""} />
              </SquareWrapper>
            </div>
          )}
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default RankProductCard;
